import React, { useRef, useState } from "react";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHConvenioDel } from "services/services-mia/programa-salud/personal/RNHConvenioDel";


export default function DeleteModal({ row, updateList, closeModal, setterRowSelected }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const [inRequest, setInRequest] = useState(false);
  const formikRef = useRef();

  const eliminarConvenio = async () => {
    setInRequest(true);
    const response = await RNHConvenioDel(credentials, {
      id: row?.id,
      version: row?.version,
    });
    setInRequest(false);
    if (response.ok) {
      setSnackBarInfo({
        message: "Régimen horario eliminado correctamente",
        severity: "success",
        open: true,
      });
      formikRef.current.resetForm();
      updateList();
      setterRowSelected({ status: false, row: {} });
      closeModal();
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        cod: row?.cod ?? "",
        ley: row?.ley ?? "",
        cargaSemanal: row?.cargaSemanal ?? "",
      }}
      onSubmit={() => {
        eliminarConvenio();
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <FormikTextInput
            fullWidth={true}
            name="cod"
            labelText="Código"
            readOnly
          />
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Eliminar" }}
            onCloseModal={closeModal}
          />
          {(inRequest) && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
